/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookDtoUpdate } from '../../models/address-book-dto-update';
import { AddressBookItem } from '../../models/address-book-item';
import { BaseResponse } from '../../models/base-response';

export interface AddressBookControllerUpdate$Params {
  id: number;
      body: AddressBookDtoUpdate
}

export function addressBookControllerUpdate(http: HttpClient, rootUrl: string, params: AddressBookControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookItem;
}>> {
  const rb = new RequestBuilder(rootUrl, addressBookControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookItem;
      }>;
    })
  );
}

addressBookControllerUpdate.PATH = '/address-book/{id}';
